import { useRef, type MutableRefObject, type ReactNode } from 'react';
import { X } from '@hungryroot/icons';

import { ModalContent } from '../Modal/Modal/ModalContent/ModalContent';
import { ModalOverlay } from '../Modal/Modal/ModalOverlay/ModalOverlay';
import styles from './OldModal.module.css';

interface Props {
  children: ReactNode;
  isOpen: boolean;
  ariaLabel: string;
  testid?: string;
  onDismiss: () => void;
  contentClassName?: string;
  overlayClassName?: string;
  clickOffSegmentEvent?: () => void;
  clickCloseSegmentEvent?: () => void;
  innerContentClassName?: string;
  closeButtonClassName?: string;
  onAnimationEnd?: () => void;
  showXButton?: boolean;
  initialFocusRef?: MutableRefObject<null>;
}

/**
 * @deprecated This modal is deprecated. Consider using other modals from this package
 * instead. This modal should only be used to make migration of dependencies easier.
 */
export function OldModal(props: Props) {
  const {
    contentClassName,
    overlayClassName,
    innerContentClassName,
    closeButtonClassName,
    isOpen,
    onDismiss,
    testid,
    ariaLabel,
    children,
    clickOffSegmentEvent,
    clickCloseSegmentEvent,
    onAnimationEnd,
    showXButton = true,
    initialFocusRef,
  } = props;

  const closeButtonRef = useRef<HTMLButtonElement | null>(null);
  const contentClassNames = [styles.content, contentClassName]
    .filter((name) => {
      return name !== undefined;
    })
    .join(' ');

  const overlayClassNames = [styles.overlay, overlayClassName]
    .filter((name) => {
      return name !== undefined;
    })
    .join(' ');

  return (
    <ModalOverlay
      onDismiss={() => {
        onDismiss();

        if (clickOffSegmentEvent) {
          clickOffSegmentEvent();
        }
      }}
      initialFocusRef={initialFocusRef ? initialFocusRef : closeButtonRef}
      className={overlayClassNames}
      data-testid={testid}
      isOpen={isOpen}
      onAnimationEnd={onAnimationEnd}
    >
      <ModalContent className={contentClassNames} ariaLabel={ariaLabel}>
        <div className={innerContentClassName}>
          {showXButton && (
            <button
              ref={closeButtonRef}
              data-testid={`${testid}-close-button`}
              className={
                closeButtonClassName ? closeButtonClassName : styles.close
              }
              aria-label={`close ${ariaLabel}`}
              onClick={() => {
                onDismiss();

                if (clickCloseSegmentEvent) {
                  clickCloseSegmentEvent();
                }
              }}
            >
              <X />
            </button>
          )}
          {children}
        </div>
      </ModalContent>
    </ModalOverlay>
  );
}
